import React from "react";
import "./TopNavbar.scss";

export class TopNavbar extends React.Component<any, any> {
    render() {
        return (<div className="top-navbar">
            <a href="https://fontannyplywajace.pl"><img className="logo" src="/zzm-logo2.png" style={{ height: "80%" }} /></a>
        </div>)
    }
}